import { children, ParentComponent } from "solid-js";

export const Layout: ParentComponent<{ class?: string }> = (props) => {
  const child = children(() => props.children);
  return <div class={`${props.class} h-full p-4 md:p-6`}>{child()}</div>;
};
